<div class="question-api" *ngIf="!isHidden">
  <div *ngIf="isLoading" class="question-api__status">
    <span>{{ 'ApiQuestionExecuting' | translate }}</span>
  </div>
  <div *ngIf="hasError && !isLoading" class="question-api__status question-api__status--error">
    <span>{{ 'ApiQuestionExecutionFailed' | translate }}</span>
  </div>
</div>
